import React from 'react';

const OfflinePage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>🚫 You are currently offline</h1>
      <p>Please check your internet connection and try again.</p>
    </div>
  );
};

export default OfflinePage;
